import { combineReducers } from 'redux'

import * as types from 'models/actionTypes'

const initialState = {
    ids: null,
}

const ids = (state = initialState.ids, action) => {
    switch (action.type) {
        case types.RECEIVE_FAVORITES:
            return action.favorites
        case types.TOGGLE_FAVORITE: {
            if (action.isFavorite) {
                const prevFavs = state ? [...state] : []
                return [...new Set([...prevFavs, action.localItemNumber])]
            }
            return state.filter((f) => f !== action.localItemNumber)
        }
        case types.TOGGLE_FAVORITES: {
            const { isFavorite, itemsToFavorite } = action
            if (isFavorite) {
                const prevFavs = state ? [...state] : []
                return [...new Set([...prevFavs, ...itemsToFavorite])]
            }
            return state.filter((f) => !itemsToFavorite.includes(f))
        }
        default:
            return state
    }
}

export default combineReducers({ ids })
